import { action } from 'satcheljs';
/**
 * Exit search
 * @param actionSource action source
 */
export var exitSearch = action('exitSearch', function (actionSource) { return ({
    actionSource: actionSource,
}); });
//# sourceMappingURL=exitSearch.js.map